import { useState } from 'react';

const faqs = [
  {
    question: "Which is the best software company in Delhi?",
    answer: "Tracklio Hub is one of the best software development companies in Delhi offering ERP, CRM, HRMS, MDM and custom software solutions for businesses.",
  },
  {
    question: "Which is the best software company in Patna Bihar?",
    answer: "Tracklio Hub is a top software company in Patna, Bihar providing ERP software, inventory management, banking software and custom app development for businesses in Bihar.",
  },
  {
    question: "What is Tracklio Hub?",
    answer: "Tracklio Hub is an all-in-one business management platform offering ERP, CRM, HRMS, inventory management, MDM and custom software development services across India.",
  },
  {
    question: "Does Tracklio Hub offer ERP software in India?",
    answer: "Yes, Tracklio Hub provides fully customizable ERP software for businesses in Delhi, Patna, Bihar and across India covering inventory, sales, HR, CRM and finance modules.",
  },
  {
    question: "Does Tracklio Hub provide Mobile Device Management (MDM)?",
    answer: "Yes, Tracklio Hub provides a complete MDM solution to manage and secure Android and iOS devices for businesses and enterprises across India.",
  },
  {
    question: "Does Tracklio Hub offer custom software development in Delhi?",
    answer: "Yes, Tracklio Hub is a custom software development company in Delhi. We build web apps, mobile apps, banking software, ERP and enterprise solutions.",
  },
  {
    question: "Can I get a free demo of Tracklio Hub?",
    answer: "Yes, Tracklio Hub offers a free demo. Visit trackliohub.com or contact our team to schedule a demo at your convenience.",
  },
  {
    question: "Does Tracklio Hub provide banking software in India?",
    answer: "Yes, Tracklio Hub develops custom banking software, cooperative banking solutions and financial management systems for businesses and institutions in India.",
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (index) => {
    setOpenIndex((prev) => (prev === index ? -1 : index));
  };

  const styles = {
    section: {
      padding: '100px 40px',
      background: '#ffffff',
      position: 'relative',
    },
    container: {
      maxWidth: '900px',
      margin: '0 auto',
    },
    header: {
      textAlign: 'center',
      marginBottom: '50px',
    },
    title: {
      fontSize: 'clamp(32px, 5vw, 48px)',
      fontWeight: '800',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      marginBottom: '16px',
      lineHeight: '1.2',
    },
    subtitle: {
      fontSize: '16px',
      color: '#6b7280',
      lineHeight: '1.7',
    },
    item: {
      borderBottom: '1px solid #e5e7eb',
    },
    questionButton: {
      width: '100%',
      textAlign: 'left',
      background: 'none',
      border: 'none',
      padding: '22px 4px',
      fontSize: '17px',
      fontWeight: '600',
      color: '#1f2937',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '16px',
    },
    icon: {
      flexShrink: 0,
      fontSize: '18px',
      color: '#667eea',
      transition: 'transform 0.25s ease',
    },
    answerWrapper: {
      overflow: 'hidden',
      transition: 'max-height 0.3s ease, opacity 0.3s ease',
    },
    answer: {
      padding: '0 4px 22px',
      fontSize: '15px',
      lineHeight: '1.8',
      color: '#4b5563',
      margin: 0,
    },
  };

  return (
    <section style={styles.section} id="faq" aria-label="Frequently Asked Questions">
      <div style={styles.container}>
        <header style={styles.header}>
          <h2 style={styles.title}>Frequently Asked Questions</h2>
          <p style={styles.subtitle}>
            Common questions about Tracklio Hub's software services in Delhi, Patna, Bihar and across India.
          </p>
        </header>

        <div>
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div style={styles.item} key={faq.question}>
                <h3 style={{ margin: 0 }}>
                  <button
                    type="button"
                    style={styles.questionButton}
                    onClick={() => toggle(index)}
                    aria-expanded={isOpen}
                    aria-controls={`faq-answer-${index}`}
                    id={`faq-question-${index}`}
                  >
                    <span>{faq.question}</span>
                    <span style={{
                      ...styles.icon,
                      transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)'
                    }} aria-hidden="true">
                      +
                    </span>
                  </button>
                </h3>
                <div
                  id={`faq-answer-${index}`}
                  role="region"
                  aria-labelledby={`faq-question-${index}`}
                  style={{
                    ...styles.answerWrapper,
                    maxHeight: isOpen ? '400px' : '0px',
                    opacity: isOpen ? 1 : 0,
                  }}
                >
                  <p style={styles.answer}>{faq.answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;